import { GeoJsonLayer, ScatterplotLayer, TextLayer } from '@deck.gl/layers';
import type { Feature } from 'geojson';
import type { PickingInfo } from '@deck.gl/core';
import type { IsadCluster } from '../MapView/utils/clusterIsad';

interface ISADGeoJsonLayerProps {
  visible: boolean;
  features: Feature[];
}

export const isadGeoJsonLayer = ({
  visible = false,
  features,
}: ISADGeoJsonLayerProps) => {
  return new GeoJsonLayer({
    id: 'isad-geojson-layer',
    data: features,
    stroked: false,
    filled: true,
    pickable: true,
    getFillColor: [255, 105, 105, 150], // Slight transparency
    visible,
  });
};

export function isadClusterLayers(
  clusters: IsadCluster[],
  visible: boolean,
  onClick: (info: PickingInfo<IsadCluster>) => boolean
) {
  return [
    new ScatterplotLayer<IsadCluster>({
      id: 'isad-clusters',
      data: clusters,
      visible,
      pickable: true,
      onClick,
      getPosition: (cluster) => cluster.position,
      getRadius: (cluster) => Math.min(28, 14 + Math.log10(cluster.count) * 4),
      radiusUnits: 'pixels',
      getFillColor: [255, 105, 105, 230],
      stroked: true,
      getLineColor: [255, 255, 255],
      lineWidthUnits: 'pixels',
      getLineWidth: 1,
    }),
    new TextLayer<IsadCluster>({
      id: 'isad-cluster-counts',
      data: clusters,
      visible,
      getPosition: (cluster) => cluster.position,
      getText: (cluster) => String(cluster.count),
      getSize: 12,
      getColor: [25, 25, 25],
      fontWeight: 'bold',
    }),
  ];
}
